<template>
    <div class="field" @click="showDropdown = false">
        <slot name="control-label"></slot>
        <div class="control is-expanded">
            <div
                :class="{ 'is-active': showDropdown }"
                class="dropdown is-fullwidth"
            >
                <div
                    class="dropdown-trigger"
                    @click.stop="showDropdown = !showDropdown"
                >
                    <button
                        :class="{ 'is-loading': loadingOptions }"
                        class="button"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                    >
                        <span class="has-text-left">
                            {{ selectedOption.name || selectedOption.title }}
                        </span>
                        <!--span 
              v-else 
              class="has-text-left">Mis proyectos</span-->
                        <span class="icon is-small is-flex-shrink-5">
                            <i class="fas fa-angle-down" aria-hidden="true"></i>
                        </span>
                    </button>
                </div>
                <div id="dropdown-menu" class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        <a
                            class="dropdown-item"
                            @click="selectedOption = defaultOption"
                            >{{ defaultOption.name || defaultOption.title }}</a
                        >
                        <hr class="dropdown-divider" />
                        <a
                            v-for="option in options"
                            :key="option._id"
                            :class="{
                                'is-active': selectedOption._id == option._id,
                            }"
                            class="dropdown-item"
                            @click="selectOption(option)"
                            >{{ option.name || option.title }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loadingOptions: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Array,
            default: () => {
                return [];
            },
        },
        defaultOption: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            showDropdown: false,
            selectedOption: this.defaultOption,
        };
    },
    watch: {
        defaultOption() {
            this.selectedOption = this.defaultOption;
        },
    },
    methods: {
        selectOption(option) {
            this.selectedOption = option;
            this.$emit('change', option);
        },
    },
};
</script>

<style></style>
